
import { UUIDInfo } from '@luxtag/papybase';
import { find, findIndex } from 'lodash';

export const MUTATE_UUIDS = 'MUTATE_UUIDS';
export const ADD_UUID = 'ADD_UUID';
export const UPDATE_UUID = 'UPDATE_UUID';

interface UUIDState {
    uuids: UUIDInfo[];
}

// initial state
const orderState: UUIDState = {
    uuids: [],
};

// getters
const getters = {
    getUUIDs: (state: UUIDState) => state.uuids,
    getUUID: (state: UUIDState) => (uuidId: number) => find(
        state.uuids, (uuid: UUIDInfo) => uuid.id === uuidId,
    ),
    getUUIDByAddress: (state: UUIDState) => (address: string) => find(
        state.uuids, (uuid: UUIDInfo) => uuid.address === address,
    ),
};

// mutations
const mutations = {
    [MUTATE_UUIDS](state: UUIDState, payload: UUIDInfo[]) {
        state.uuids = payload;
    },
    [ADD_UUID](state: UUIDState, payload: UUIDInfo) {
        state.uuids.push(payload);
    },
    [UPDATE_UUID](state: UUIDState, payload: UUIDInfo) {
        const theIndex = findIndex(state.uuids, uuid => uuid.id === payload.id);
        state.uuids.splice(theIndex, 1, payload);
    },
};

// actions
const actions = {
    [MUTATE_UUIDS](context: any, payload: any) {
        context.commit(MUTATE_UUIDS, payload);
    },
};


export default {
    state: orderState,
    getters,
    actions,
    mutations,
};
